import { render, staticRenderFns } from "./BaseComboBox.vue?vue&type=template&id=283161d6&scoped=true&"
import script from "./BaseComboBox.vue?vue&type=script&lang=js&"
export * from "./BaseComboBox.vue?vue&type=script&lang=js&"
import style0 from "./BaseComboBox.vue?vue&type=style&index=0&id=283161d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283161d6",
  null
  
)

export default component.exports